import { render, staticRenderFns } from "./IdentityProvider.vue?vue&type=template&id=a0eb3180&scoped=true"
import script from "./IdentityProvider.vue?vue&type=script&lang=js"
export * from "./IdentityProvider.vue?vue&type=script&lang=js"
import style0 from "./IdentityProvider.vue?vue&type=style&index=0&id=a0eb3180&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb3180",
  null
  
)

export default component.exports